import axios from "axios";

export default {
  async getEmailSubscriptions() {
    return await axios({
      url: '/api/emailsubscription',
    }).then(r => r.data);
  },
  async saveSubscriptions(data) {
    return await axios({
      url: '/api/emailsubscription',
      method: 'POST',
      data
    }).then(r => r.data);
  },
};
